import React, { FC } from 'react';
import { CircularProgressProps } from '@mui/material/CircularProgress';
import * as S from './styles';

export interface LoadingSpinnerProps extends CircularProgressProps {
  minHeight?: string | number;
}

/**
 * Renders a loading spinner component with customizable properties.
 */
export const LoadingSpinner: FC<LoadingSpinnerProps> = ({
  thickness = 2,
  minHeight = '400px',
  size = '100px',
  ...props
}: LoadingSpinnerProps): React.ReactElement => (
  <S.LoadingSpinner minHeight={minHeight}>
    <S.CircularProgress size={size} thickness={thickness} {...props} />;
  </S.LoadingSpinner>
);
